import { DOMAINS } from 'i18n'
import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import { escape } from 'utils'
import { BRAND, PROTOCOL_SCHEMA } from 'utils/settings'

// DOCS https://github.com/garmeeh/next-seo

const MetaSeo = ({ seo, hreflangs, additionalMetaTags = null }) => {
  const { title = '', description = '', image = '', canonicalUrl = '', noindex = false } = seo || {}

  const router = useRouter()

  const getDomain = () => {
    return `${PROTOCOL_SCHEMA}://${router?.locale ? DOMAINS[router?.locale] : DOMAINS['it']}`
  }

  const hreflangLocale = hreflangs.find((h) => h.locale === (router?.locale || 'it'))
  const ogLocale =
    hreflangLocale && hreflangLocale?.hrefLang ? hreflangLocale.hrefLang.replace('-', '_') : 'it'
  const ogImage = image || `${getDomain()}/images/logo.png`

  // rimuovo gli hreflang per lingue non pubblicate
  let hreflangsCleaned = hreflangs
  try {
    const urlHreflangLocale = new URL(hreflangLocale?.href)
    if (
      urlHreflangLocale?.pathname !== '' &&
      urlHreflangLocale?.pathname !== '/' &&
      urlHreflangLocale?.pathname !== '/es/' &&
      urlHreflangLocale?.pathname !== '/fr/'
    ) {
      hreflangsCleaned = hreflangsCleaned.filter((h) => {
        const href = new URL(h?.href)
        return (
          href?.pathname !== '' &&
          href?.pathname !== '/' &&
          href?.pathname !== '/es/' &&
          href?.pathname !== '/fr/'
        )
      })
    }
  } catch (e) {
    hreflangsCleaned = hreflangs
  }

  const og = {
    locale: ogLocale,
    site_name: BRAND,
    url: hreflangLocale?.href,
    title,
    description,
    images: ogImage ? [{ url: ogImage }] : [],
    type: 'website',
  }

  const props = {
    title: escape(title),
    description: escape(description),
    additionalMetaTags,
    openGraph: og,
    languageAlternates: hreflangsCleaned,
  }

  if (noindex) props.noindex = true
  else {
    if (canonicalUrl) props.canonical = canonicalUrl
    else props.canonical = hreflangLocale?.href
  }

  return <NextSeo {...props} />
}

export default MetaSeo
